import { FC } from "react";
import { AgentNewThreadMessage } from "./types";
import "./NewThreadMessage.css";
import { useMessageThreadInfo } from "../../hooks/useMessageThreadInfo";
import { MessageThreadType } from "winslow-core";
import { ThreadInfo } from "./ThreadInfo";

interface NewThreadMessageProps {
  message: AgentNewThreadMessage;
}

export const NewThreadMessage: FC<NewThreadMessageProps> = ({ message }) => {
  const contextInfo = useMessageThreadInfo(message.thread);
  if (!contextInfo) {
    return null;
  }

  return (
    <div className="agent-chat-history-item">
      <div className="new-thread-message">
        <div className="new-thread-divider"></div>

        {contextInfo.threadType === MessageThreadType.NONE && (
          <ThreadInfo label="Removed Context" className="centered" />
        )}

        {contextInfo.threadType === MessageThreadType.PERSONA && (
          <ThreadInfo
            label={contextInfo.label || "Persona Context Changed"}
            className="centered"
          />
        )}

        {contextInfo.threadType === MessageThreadType.EMPLOYEE && (
          <ThreadInfo
            avatar={contextInfo.avatar}
            label={contextInfo.label || "Employee Context Changed"}
            className="centered"
          />
        )}
      </div>
    </div>
  );
};
